/* MARQUE v47: accessible carousel arrows and compact size disclosures. */
(() => {
  'use strict';
  if (window.marqueV47Init) return;
  window.marqueV47Init = true;
  const reduce = () => matchMedia('(prefers-reduced-motion: reduce)').matches;
  const cards = grid => [...grid.querySelectorAll(':scope > .marque-card')];
  const step = (grid, arr) => arr.length > 1 ? Math.max(1,arr[1].offsetLeft-arr[0].offsetLeft) : (arr[0]?.offsetWidth||1);
  function refresh(panel) {
    if (!panel || panel.hidden) return;
    const grid = panel.querySelector('.marque-featured__grid');
    const pager = panel.querySelector('[data-marque-pager]');
    if (!grid || !pager) return;
    const arr = cards(grid);
    const useful = arr.length > 1 && grid.scrollWidth > grid.clientWidth + 4;
    pager.hidden = !useful;
    if (!useful) return;
    const index = Math.max(0, Math.min(arr.length - 1, Math.round(grid.scrollLeft / step(grid, arr))));
    const count = pager.querySelector('[data-marque-count]');
    if (count) {
      count.textContent = String(index + 1).padStart(2,'0') + ' / ' + String(arr.length).padStart(2,'0');
      count.setAttribute('aria-label', 'Product ' + (index+1) + ' of ' + arr.length);
    }
    const prev = pager.querySelector('[data-marque-prev]');
    const next = pager.querySelector('[data-marque-next]');
    if (prev) prev.disabled = index === 0;
    if (next) next.disabled = index >= arr.length - 1 || grid.scrollLeft + grid.clientWidth >= grid.scrollWidth - 3;
  }
  let raf = 0;
  const refreshAll = () => document.querySelectorAll('[data-marque-featured-panel]').forEach(refresh);
  function schedule() { if (raf) return; raf = requestAnimationFrame(() => {raf=0; refreshAll();}); }
  document.addEventListener('click', event => {
    if (!(event.target instanceof Element)) return;
    const arrow = event.target.closest('[data-marque-prev],[data-marque-next]');
    if (arrow) {
      if (arrow.disabled) return;
      const panel = arrow.closest('[data-marque-featured-panel]');
      const grid = panel?.querySelector('.marque-featured__grid');
      if (!grid) return;
      const arr = cards(grid), distance=step(grid,arr);
      const index=Math.round(grid.scrollLeft/distance);
      const offset=arrow.hasAttribute('data-marque-next')?1:-1;
      const target=Math.max(0,Math.min(arr.length-1,index+offset));
      grid.scrollTo({left:target*distance,behavior:reduce()?'auto':'smooth'});
      return;
    }
    if (event.target.closest('[data-marque-featured-tab]')) {
      requestAnimationFrame(() => requestAnimationFrame(refreshAll));
    }
  });
  document.addEventListener('scroll',event => {
    if (event.target instanceof Element && event.target.matches('.marque-featured__grid')) schedule();
  },true);
  document.addEventListener('toggle',event => {
    const details=event.target;
    if (!(details instanceof HTMLDetailsElement)||!details.matches('.marque-card__sizes')||!details.open) return;
    const list=details.closest('.marque-featured__grid,.marque-sig__grid');
    if (!list) return;
    list.querySelectorAll('.marque-card__sizes[open]').forEach(item => {if (item !== details) item.open = false;});
  },true);
  document.addEventListener('keydown',event => {
    if(event.key !== 'Escape' || !(event.target instanceof Element)) return;
    const details=event.target.closest('.marque-card__sizes[open]');
    if (details) {details.open=false;details.querySelector('summary')?.focus();}
  });
  window.addEventListener('resize',schedule,{passive:true});
  document.addEventListener('shopify:section:load',schedule);
  document.addEventListener('DOMContentLoaded',schedule,{once:true});
  schedule();
})();
